import { create } from 'zustand';
import { authApi } from '../lib/api';

interface User {
  id: string;
  email: string;
  name: string;
  phone: string;
  business_number: string | null;
  business_name: string | null;
  roles: { id: string; user_id: string; role: string; is_verified: number }[];
}

interface AuthState {
  user: User | null;
  token: string | null;
  loading: boolean;
  signIn: (email: string, password: string) => Promise<void>;
  signUp: (data: any) => Promise<void>;
  signOut: () => void;
  loadUser: () => Promise<void>;
  hasRole: (role: string) => boolean;
  isVerified: (role: string) => boolean;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  user: null,
  token: localStorage.getItem('carp2p_token'),
  loading: false,

  signIn: async (email, password) => {
    set({ loading: true });
    try {
      const res: any = await authApi.signIn({ email, password });
      localStorage.setItem('carp2p_token', res.token);
      localStorage.setItem('carp2p_user', JSON.stringify(res.user));
      set({ user: res.user, token: res.token, loading: false });
    } catch (err) {
      set({ loading: false });
      throw err;
    }
  },

  signUp: async (data) => {
    set({ loading: true });
    try {
      const res: any = await authApi.signUp(data);
      localStorage.setItem('carp2p_token', res.token);
      localStorage.setItem('carp2p_user', JSON.stringify(res.user));
      set({ user: res.user, token: res.token, loading: false });
    } catch (err) {
      set({ loading: false });
      throw err;
    }
  },

  signOut: () => {
    localStorage.removeItem('carp2p_token');
    localStorage.removeItem('carp2p_user');
    set({ user: null, token: null });
  },

  loadUser: async () => {
    const token = localStorage.getItem('carp2p_token');
    if (!token) return;
    try {
      const res: any = await authApi.me();
      localStorage.setItem('carp2p_user', JSON.stringify(res.user));
      set({ user: res.user, token });
    } catch {
      localStorage.removeItem('carp2p_token');
      localStorage.removeItem('carp2p_user');
      set({ user: null, token: null });
    }
  },

  hasRole: (role: string) => {
    const user = get().user;
    return user?.roles?.some(r => r.role === role) || false;
  },

  isVerified: (role: string) => {
    const user = get().user;
    return user?.roles?.some(r => r.role === role && r.is_verified) || false;
  },
}));
